import React from 'react';
import GenericPrivacyPolicyPage from '../../../components/GenericPrivacyPolicyPage';

const APP_NAME = 'CollectX';
const LAST_UPDATED_DATE = 'May 2025'; // Extracted from the original content

// The original PRIVACY_POLICY_CONTENT, excluding the "Last Updated" line as it's now a prop.
const PRIVACY_POLICY_CONTENT = `
This Privacy Policy describes how your information is handled when you use the CollectX application ("App").

1. Information We Collect
We do not collect any Personally Identifiable Information (PII). All collection data, images, and user preferences are stored locally on your device. No collectible or collection data is stored by us or any third party.

2. Data Storage and Usage
Your collection, images, categories, and insights are stored securely using your device's local storage and filesystem. This data is solely for your convenience and app functionality.

3. Premium Features
If you subscribe to Premium Features, the purchase process is managed entirely through your device's app store (e.g., Apple App Store, Google Play Store). This is handled securely by the app store provider according to their privacy policies. Premium status is cached using a secure backend but is not linked to your collection data.

4. AI Analysis and Third-Party Processing
When you scan a collectible, the image and necessary metadata are sent securely to our third-party service providers for AI-powered analysis. Our providers include specialized image processing and machine learning services. While this data is processed by third parties, we ensure that:
- No personally identifiable information is transmitted
- Data is processed confidentially and cannot be linked to specific individuals
- Images are processed solely for the purpose of analysis and identification
- Third-party providers are bound by strict data protection agreements
- Data transmission is secured using industry-standard encryption protocols
The analysis results are returned to your device and stored locally. We do not retain any images or data from this process on our servers. The analysis is performed in real-time, and no data is stored or used for any other purpose.

5. Data Security
We rely on the security features of your device's operating system and local storage to protect your data. While we take reasonable steps to safeguard transmitted images for AI analysis, no method of electronic storage or transmission is 100% secure.

6. Data Retention
All collection data remains on your device until you delete it or uninstall the App. Images sent for AI analysis are not retained by our backend after processing.

7. Children's Privacy
This App is not directed to children under the age of 13. We do not knowingly collect any information from children under 13. If you believe we may have inadvertently collected such information, please contact us so we can promptly remove it.

8. Changes to This Privacy Policy
We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on our website. You are advised to review this Privacy Policy periodically for any changes.

9. Contact Us
If you have any questions about this Privacy Policy, please contact us at <a href="mailto:support.collectx@codemates.app" style="color:#007bff;text-decoration:none;">support.collectx@codemates.app</a>.`;

function CollectXPrivacyPolicyPage() {
  return (
    <GenericPrivacyPolicyPage
      appName={APP_NAME}
      lastUpdatedDate={LAST_UPDATED_DATE}
      policyContent={PRIVACY_POLICY_CONTENT}
    />
  );
}

export default CollectXPrivacyPolicyPage;
